import React from 'react';
import { Box, Container, Typography, Grid, Avatar, Link } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

const Footer = () => {

  const handleOpenTawk = (e) => {
    e.preventDefault();
    if (window.Tawk_API && window.Tawk_API.maximize) {
      window.Tawk_API.maximize();
    }
  };

  const footerSections = [
    {
      title: 'Product',
      links: [
        { label: 'Features', href: '/#features' },
        { label: 'Pricing', href: '/#pricing' },
        // { label: 'Security', href: '#' },
      ],
    },
    {
      title: 'Company',
      links: [
        { label: 'About', href: '/home/about' },
        { label: 'Blog', href: '#' },
        { label: 'Careers', href: '#' },
      ],
    },
    {
      title: 'Legal',
      links: [
        { label: 'Privacy', href: '/privacy-policy' },
        { label: 'Terms', href: '/tnc' },
        { label: 'Contact', action: 'tawk' },
      ],
    },
  ];

  return (
    <Box
      component="footer"
      sx={{
        background: 'linear-gradient(180deg, #0f172a 0%, #020617 100%)',
        color: '#cbd5e1',
        pt: 9,
        pb: 4,
      }}
    >
      <Container maxWidth="xl" sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box sx={{ width: '100%', maxWidth: '1200px' }}>
          <Grid container justifyContent="space-between">

            {/* BRAND */}
            <Grid item sx={{ width: 280 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
                <Avatar
                  sx={{
                    width: 36,
                    height: 36,
                    bgcolor: '#10b981',
                    borderRadius: '8px',
                    fontWeight: 700,
                  }}
                >
                  {'{a}'}
                </Avatar>

                <Typography
                  sx={{
                    fontSize: '1.4rem',
                    fontWeight: 700,
                    color: '#ffffff',
                  }}
                >
                  getlista
                </Typography>
              </Box>

              <Typography
                sx={{
                  fontSize: '0.95rem',
                  lineHeight: 1.6,
                  color: '#94a3b8',
                }}
              >
                Discover experienced talent beyond boundaries.
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                <Typography component="span" sx={{ fontSize: '0.95rem', color: '#94a3b8' }}>
                  Synthesized by AI
                </Typography>
                <AutoAwesomeIcon sx={{ fontSize: 16, color: '#94a3b8' }} aria-hidden />
              </Box>
            </Grid>

            {/* FOOTER LINKS */}
            {footerSections.map((section, index) => (
              <Grid item key={index} sx={{ width: 160 }}>
                <Typography
                  sx={{
                    fontSize: '1rem',
                    fontWeight: 600,
                    color: '#ffffff',
                    mb: 2,
                  }}
                >
                  {section.title}
                </Typography>

                {section.links.map((item, idx) => (
                  <Typography key={idx} sx={{ mb: 1.2 }}>
                    {item.action === 'tawk' ? (
                      <Link
                        href="#"
                        underline="none"
                        onClick={handleOpenTawk}
                        sx={{
                          fontSize: '0.95rem',
                          color: '#94a3b8',
                          cursor: 'pointer',
                          '&:hover': { color: '#ffffff' },
                        }}
                      >
                        {item.label}
                      </Link>
                    ) : (
                      <Link
                        href={item.href}
                        underline="none"
                        sx={{
                          fontSize: '0.95rem',
                          color: '#94a3b8',
                          '&:hover': { color: '#ffffff' },
                        }}
                      >
                        {item.label}
                      </Link>
                    )}
                  </Typography>
                ))}
              </Grid>
            ))}
          </Grid>

          {/* BOTTOM */}
          <Box
            sx={{
              mt: 7,
              pt: 3,
              borderTop: '1px solid #1e293b',
              textAlign: 'center',
            }}
          >
            <Typography sx={{ fontSize: '0.9rem', color: '#94a3b8' }}>
              © 2026 Getlista. All rights reserved.
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;